import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Chip, Divider, TextField } from "@mui/material";
import BasicButtons from "../../UI/BasicButtons";
import {
  useGetOrganizationQuery,
  useUpdateOrganizationMutation,
} from "../../../store/organizationApi";
import SnackBar from "../../UI/SnackBar";

function Organization({ updateRowsHandler, onClose }) {
  const { data, isLoading } = useGetOrganizationQuery();
  const [updateData] = useUpdateOrganizationMutation();
  const [title, setTitle] = useState("");
  const [shortTitle, setShortTitle] = useState("");
  const [address, setAddress] = useState("");
  const [inn, setInn] = useState("");
  const [regNumber, setRegNumber] = useState("");
  const [okpo, setOkpo] = useState("");
  const [bik, setBik] = useState("");
  const [ls, setLs] = useState("");
  const [bank, setBank] = useState("");
  const [leader, setLeader] = useState("");
  const [surname, setSurname] = useState("");
  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    const setDataToStates = async () => {
      try {
        const organization = await data.data.attributes;
        setTitle(organization.title);
        setShortTitle(organization.shortTitle);
        setAddress(organization.address);
        setRegNumber(organization.regNumber);
        setOkpo(organization.okpo);
        setBik(organization.bik);
        setLs(organization.ls);
        setBank(organization.bank);
        setLeader(organization.leader);
        setSurname(organization.surname);
        setName(organization.name);
        setLastname(organization.lastname);
        setInn(organization.inn);
      } catch (error) {}
    };
    setDataToStates();
  }, [data]);

  const formSubmitHandler = async (event) => {
    event.preventDefault();
    window.confirm("Вы уверены?");
    const updates = {
      title,
      shortTitle,
      address,
      regNumber,
      okpo,
      bik,
      ls,
      bank,
      leader,
      surname,
      name,
      lastname,
      inn,
    };
    updateData(updates);
    setSnackOpen(true);
  };

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  if (isLoading) return <h1>Loading</h1>;

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <SnackBar
        snackOpen={snackOpen}
        typeOfMessage={"success"}
        textOfMessage={"Успешно!"}
        snackClose={() => setSnackOpen(false)}
      />
      <DividerStyled sx={{ margin: "20px 0" }} width="60%">
        <Chip label="Данные организации" />
      </DividerStyled>
      <BlockStyled
        width="60%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="outlined-basic"
          label="Название"
          variant="standard"
          value={title}
          onChange={(event) => inputChangeHandler(event, setTitle)}
          width="80%"
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Короткое название"
          variant="outlined"
          width="18%"
          size="small"
          value={shortTitle}
          onChange={(event) => inputChangeHandler(event, setShortTitle)}
        />
      </BlockStyled>
      <BlockStyled
        width="60%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          width="50%"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="ИНН"
          variant="outlined"
          width="25%"
          value={inn}
          onChange={(event) => inputChangeHandler(event, setInn)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Регистрационный номер"
          variant="outlined"
          value={regNumber}
          onChange={(event) => inputChangeHandler(event, setRegNumber)}
        />
      </BlockStyled>
      <BlockStyled
        width="60%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      ></BlockStyled>
      <BlockStyled
        width="60%"
        margin="0 0 40px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="outlined-basic"
          label="ОКПО"
          variant="outlined"
          value={okpo}
          onChange={(event) => inputChangeHandler(event, setOkpo)}
          width="15%"
        />
        <TextFieldStyled
          id="outlined-basic"
          label="БИК"
          variant="outlined"
          value={bik}
          onChange={(event) => inputChangeHandler(event, setBik)}
          width="15%"
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Лицевой Счет"
          variant="outlined"
          value={ls}
          onChange={(event) => inputChangeHandler(event, setLs)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Банк"
          variant="outlined"
          value={bank}
          onChange={(event) => inputChangeHandler(event, setBank)}
          width="40%"
        />
      </BlockStyled>
      <BlockStyled
        width="60%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="outlined-basic"
          label="Должность руководителя"
          variant="outlined"
          value={leader}
          onChange={(event) => inputChangeHandler(event, setLeader)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Фамилия"
          variant="outlined"
          value={surname}
          onChange={(event) => inputChangeHandler(event, setSurname)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Имя"
          variant="outlined"
          value={name}
          onChange={(event) => inputChangeHandler(event, setName)}
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Отчество"
          variant="outlined"
          value={lastname}
          onChange={(event) => inputChangeHandler(event, setLastname)}
        />
      </BlockStyled>
      <BlockStyled
        width="60%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="flex-end"
      >
        <BasicButtons type="submit">Сохранить</BasicButtons>
      </BlockStyled>
    </StyledForm>
  );
}

export default Organization;

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStyled = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  width: ${(props) => props.width};
`;

const StyledForm = styled.form`
  margin: 10px 10px;
`;
